export enum ManageActionTypes {
  SET_MANAGE_ORDERS_DATA = "SET_MANAGE_ORDERS_DATA",
  SET_MANAGE_USERS_DATA = "SET_MANAGE_USERS_DATA",
}
